// jQuery(document).ready(function ($) {
//   // Refresh all instances initially
//   $(".modelSelect").selectpicker("refresh");
//   $(".dealerSelect").selectpicker("refresh");

//   // Make Change Handler
//   $(".makeSelect").on("change", function () {
//     const container = $(this).closest(".select-group");
//     const id = $(this).find("option:selected").data("id");

//     // Model Change Handler
//     $(".modelSelect").on("change", function () {
//       const container = $(this).closest(".select-group");
//       container.find(".varient").removeClass("d-none");
//     });
//     const modelSelect = container.find(".modelSelect");
//     console.log('modelSelect', modelSelect);
//     modelSelect.closest(".modelContainer").removeClass("d-none");
//     modelSelect.find("option").hide();
//     modelSelect.find('option[data-parent="' + id + '"]').show();
//     modelSelect.selectpicker("refresh");

//     // Location Change Handler
//     $(".locationSelect").on("change", function () {
//       const container = $(this).closest(".select-group"); // New wrapper class for each set
//       container.find(".dealerContainer").removeClass("d-none");
//       const loc_val = $(this).find("option:selected").val();
//       const dealerSelect = container.find(".dealerSelect");
//       dealerSelect.find("option").hide();
//       dealerSelect.find('option[data-dealer-city="' + loc_val + '"]').show();
//       dealerSelect.selectpicker("refresh");
//     });
//   });
// });.



// prefect 
// jQuery(document).ready(function ($) {
//   // Refresh select pickers initially
//   $(".modelSelect").selectpicker("refresh");
//   $(".dealerSelect").selectpicker("refresh");
//   $(".varientSelect").selectpicker("refresh");

//   // Event handler for location change
//   $(".locationSelect").on("change", function () {
//     const $form = $(this).closest("form");
//     $form.find(".dealerContainer").removeClass("d-none");
//     const loc_val = $(this).find("option:selected").val();
//     const $dealerSelect = $form.find(".dealerSelect");
//     $dealerSelect.find("option").hide();
//     $dealerSelect.find(`option[data-dealer-city="${loc_val}"]`).show();
//     $dealerSelect.selectpicker("refresh");
//   });

//   // Event handler for make change
//   $(".makeSelect").on("change", function () {
//     const $form = $(this).closest("form");
//     const id = $(this).find("option:selected").data("id");
//     const selectedMake = $(this).find("option:selected").text().trim();

//     $form.find(".modelContainer").removeClass("d-none");

//     const isKiaOrPeugeot = selectedMake === "KIA" || selectedMake === "Peugeot";
//     const $modelSelect = $form.find(".modelSelect");
//     const $modelContainer = $modelSelect.closest(".modelContainer");
//     const $modelInput = $modelContainer.next(".form-floating");
//     const $variantSelect = $form.find(".varientSelect");
//     const $variantContainer = $variantSelect.closest(
//       ".varientContainer, .varientSelector"
//     );
//     const $variantInput = $form.find(".varientInput").closest(".form-floating");

//     if (isKiaOrPeugeot) {
//       // For KIA or Peugeot
//       $modelSelect.find("option").hide();
//       $modelSelect.find(`option[data-parent="${id}"]`).show();
//       $modelSelect.selectpicker("refresh");

//       $modelContainer.removeClass("d-none");
//       $modelInput.addClass("d-none");

//       $variantInput.addClass("d-none");
//       $variantContainer.addClass("d-none");
//     } else {
//       // For other makes
//       $modelContainer.addClass("d-none");
//       $modelInput.removeClass("d-none");

//       $variantContainer.addClass("d-none");
//       $variantInput.addClass("d-none");
//     }

//     $variantSelect.selectpicker("refresh");
//   });

//   // Event handler for model change (for KIA or Peugeot)
//   $(".modelSelect").on("change", function () {
//     const $form = $(this).closest("form");
//     const selectedMake = $form.find(".makeSelect option:selected").val().trim();
//     const isKiaOrPeugeot = selectedMake === "kia" || selectedMake === "peugeot";

//     if (isKiaOrPeugeot) {
//       const modelId = $(this).find("option:selected").attr("data-id");
//       const $variantSelect = $form.find(".varientSelect");
//       const $variantContainer = $form.find(
//         ".varientContainer, .varientSelector"
//       ); // Changed this line
//       const $variantInput = $form
//         .find(".varientInput")
//         .closest(".form-floating");

//       // First, show the container
//       $variantContainer.removeClass("d-none");

//       // Then handle the options
//       $variantSelect.find("option").hide();
//       $variantSelect.find(`option[data-parent="${modelId}"]`).show();

//       // Ensure input is hidden and container is visible
//       $variantInput.addClass("d-none");

//       // Refresh the selectpicker
//       $variantSelect.selectpicker("refresh");
//     }
//   });

//   // Event handler for model input (for other makes)
//   $(".model").on("input", function () {
//     const $form = $(this).closest("form");
//     const selectedMake = $form.find(".makeSelect option:selected").val().trim();
//     const isKiaOrPeugeot = selectedMake === "kia" || selectedMake === "peugeot";
//     const $variantContainer = $form.find(".varientContainer, .varientSelector");
//     const $variantInput = $form.find(".varientInput").closest(".form-floating");

//     $variantContainer.addClass("d-none");

//     if (!isKiaOrPeugeot) {
//       if ($(this).val().trim() !== "") {
//         $variantInput.removeClass("d-none");
//       } else {
//         $variantInput.addClass("d-none");
//       }
//     }
//   });

//   // for 2nd step
//   $(".modelSelect").on("change", function () {
//     const $form = $(this).closest("form");
//     $form.find(".varientContainer").removeClass("d-none");
//   });

//   $(".model").on("input", function () {
//     const $form = $(this).closest("form");
//     $form.find(".varientInput").closest(".form-floating").removeClass("d-none");
//   });
// });


// amaizng 
// jQuery(document).ready(function ($) {
//   // Refresh select pickers initially
//   $(".modelSelect").selectpicker("refresh");
//   $(".dealerSelect").selectpicker("refresh");
//   $(".varientSelect").selectpicker("refresh");

//   // Event handler for location change
//   $(".locationSelect").on("change", function () {
//     const $form = $(this).closest("form");
//     $form.find(".dealerContainer").removeClass("d-none");
//     const loc_val = $(this).find("option:selected").val();
//     const $dealerSelect = $form.find(".dealerSelect");
//     $dealerSelect.find("option").hide();
//     $dealerSelect.find(`option[data-dealer-city="${loc_val}"]`).show();
//     $dealerSelect.selectpicker("refresh");
//   });

//   // Event handler for make change
//   $(".makeSelect").on("change", function () {
//     const $form = $(this).closest("form");
//     const id = $(this).find("option:selected").data("id");
//     const selectedMake = $(this).find("option:selected").text().trim();

//     // Reset model and variant values and containers
//     const $modelSelect = $form.find(".modelSelect");
//     const $modelContainer = $modelSelect.closest(".modelContainer");
//     const $modelInput = $modelContainer.next(".form-floating");
//     const $variantSelect = $form.find(".varientSelect");
//     const $variantContainer = $variantSelect.closest(".varientContainer, .varientSelector");
//     const $variantInput = $form.find(".varientInput").closest(".form-floating");

//     // Reset model select and input
//     $modelSelect.val("").selectpicker("refresh");
//     $modelInput.find("input").val("");
//     $modelContainer.addClass("d-none");
//     $modelInput.addClass("d-none");

//     // Reset variant select and input
//     $variantSelect.val("").selectpicker("refresh");
//     $variantInput.find("input").val("");
//     $variantContainer.addClass("d-none");
//     $variantInput.addClass("d-none");

//     const isKiaOrPeugeot = selectedMake === "KIA" || selectedMake === "Peugeot";

//     if (isKiaOrPeugeot) {
//       // For KIA or Peugeot
//       $modelSelect.find("option").hide();
//       $modelSelect.find(`option[data-parent="${id}"]`).show();
//       $modelSelect.selectpicker("refresh");

//       $modelContainer.removeClass("d-none");
//       $modelInput.addClass("d-none");

//       $variantInput.addClass("d-none");
//       $variantContainer.addClass("d-none");
//     } else {
//       // For other makes
//       $modelContainer.addClass("d-none");
//       $modelInput.removeClass("d-none");

//       $variantContainer.addClass("d-none");
//       $variantInput.addClass("d-none");
//     }

//     $variantSelect.selectpicker("refresh");
//   });

//   // Event handler for model change (for KIA or Peugeot)
//   $(".modelSelect").on("change", function () {
//     const $form = $(this).closest("form");
//     const selectedMake = $form.find(".makeSelect option:selected").val().trim();
//     const isKiaOrPeugeot = selectedMake === "kia" || selectedMake === "peugeot";

//     if (isKiaOrPeugeot) {
//       const modelId = $(this).find("option:selected").attr("data-id");
//       const $variantSelect = $form.find(".varientSelect");
//       const $variantContainer = $form.find(".varientContainer, .varientSelector");
//       const $variantInput = $form.find(".varientInput").closest(".form-floating");

//       // First, show the container
//       $variantContainer.removeClass("d-none");

//       // Then handle the options
//       $variantSelect.find("option").hide();
//       $variantSelect.find(`option[data-parent="${modelId}"]`).show();

//       // Ensure input is hidden and container is visible
//       $variantInput.addClass("d-none");

//       // Refresh the selectpicker
//       $variantSelect.selectpicker("refresh");
//     }
//   });

//   // Event handler for model input (for other makes)
//   $(".model").on("input", function () {
//     const $form = $(this).closest("form");
//     const selectedMake = $form.find(".makeSelect option:selected").val().trim();
//     const isKiaOrPeugeot = selectedMake === "kia" || selectedMake === "peugeot";
//     const $variantContainer = $form.find(".varientContainer, .varientSelector");
//     const $variantInput = $form.find(".varientInput").closest(".form-floating");

//     $variantContainer.addClass("d-none");

//     if (!isKiaOrPeugeot) {
//       if ($(this).val().trim() !== "") {
//         $variantInput.removeClass("d-none");
//       } else {
//         $variantInput.addClass("d-none");
//       }
//     }
//   });

//   // for 2nd step
//   $(".modelSelect").on("change", function () {
//     const $form = $(this).closest("form");
//     $form.find(".varientContainer").removeClass("d-none");
//   });

//   $(".model").on("input", function () {
//     const $form = $(this).closest("form");
//     $form.find(".varientInput").closest(".form-floating").removeClass("d-none");
//   });
// });

jQuery(document).ready(function ($) {
  // Configure selectpicker to show "Select" instead of "Nothing selected"
  $.fn.selectpicker.Constructor.DEFAULTS.noneSelectedText = 'Select';

  // Refresh select pickers initially
  $(".modelSelect").selectpicker("refresh");
  $(".dealerSelect").selectpicker("refresh");
  $(".varientSelect").selectpicker("refresh");

  // Event handler for location change
  $(".locationSelect").on("change", function () {
    const $form = $(this).closest("form");
    // $form.find(".dealerContainer").removeClass("d-none");
    const loc_val = $(this).find("option:selected").val();
    const $dealerSelect = $form.find(".dealerSelect");
    $dealerSelect.find("option").hide();
    $dealerSelect.find(`option[data-dealer-city="${loc_val}"]`).show();
    $dealerSelect.selectpicker("refresh");
  });

  // Event handler for make change
  $(".makeSelect").on("change", function () {
    const $form = $(this).closest("form");
    const id = $(this).find("option:selected").data("id");
    const selectedMake = $(this).find("option:selected").text().toLowerCase().trim();

    // Reset model and variant values and containers
    const $modelSelect = $form.find(".modelSelect");
    const $modelContainer = $modelSelect.closest(".modelContainer");
    const $modelInput = $modelContainer.next(".form-floating");
    const $variantSelect = $form.find(".varientSelect");
    const $variantContainer = $variantSelect.closest(".varientContainer, .varientSelector");
    const $variantInput = $form.find(".varientInput").closest(".form-floating");

    // Reset model select and input
    $modelSelect.val("").selectpicker("refresh");
    $modelInput.find("input").val("");
    // $modelContainer.addClass("d-none");
    $modelInput.addClass("d-none");

    // Reset variant select and input
    $variantSelect.val("").selectpicker("refresh");
    $variantInput.find("input").val("");
    // $variantContainer.addClass("d-none");
    $variantInput.addClass("d-none");

    const isKiaOrPeugeot = selectedMake === "kia" || selectedMake === "KIA" || selectedMake === "peugeot" || selectedMake === "Peugeot";

    if (isKiaOrPeugeot) {
      // For KIA or Peugeot
      $modelSelect.find("option").hide();
      $modelSelect.find(`option[data-parent="${id}"]`).show();
      $modelSelect.selectpicker("refresh");

      $modelContainer.removeClass("d-none");
      $modelInput.addClass("d-none");

      $variantInput.addClass("d-none");
      // $variantContainer.addClass("d-none");
    } else {
      // For other makes
      $modelContainer.addClass("d-none");
      $modelInput.removeClass("d-none");

      // $variantContainer.addClass("d-none");
      $variantInput.addClass("d-none");
    }

    $variantSelect.selectpicker("refresh");
  });

  // Event handler for model change (for KIA or Peugeot)
  $(".modelSelect").on("change", function () {
    const $form = $(this).closest("form");
    const selectedMake = $form.find(".makeSelect option:selected").val().toLowerCase().trim();
    const isKiaOrPeugeot = selectedMake === "kia" || selectedMake === "peugeot";

    if (isKiaOrPeugeot) {
      const modelId = $(this).find("option:selected").attr("data-id");
      const $variantSelect = $form.find(".varientSelect");
      const $variantContainer = $form.find(".varientContainer, .varientSelector");
      const $variantInput = $form.find(".varientInput").closest(".form-floating");

      // First, show the container
      // $variantContainer.removeClass("d-none");

      // Then handle the options
      $variantSelect.find("option").hide();
      $variantSelect.find(`option[data-parent="${modelId}"]`).show();

      // Ensure input is hidden and container is visible
      $variantInput.addClass("d-none");

      // Refresh the selectpicker
      $variantSelect.selectpicker("refresh");
    }
  });

  // Event handler for model input (for other makes)
  $(".model").on("input", function () {
    const $form = $(this).closest("form");
    const selectedMake = $form.find(".makeSelect option:selected").val().toLowerCase().trim();
    const isKiaOrPeugeot = selectedMake === "kia" || selectedMake === "peugeot";
    const $variantContainer = $form.find(".varientContainer, .varientSelector");
    const $variantInput = $form.find(".varientInput").closest(".form-floating");

    $variantContainer.addClass("d-none");

    if (!isKiaOrPeugeot) {
      if ($(this).val().trim() !== "") {
        $variantInput.removeClass("d-none");
      } else {
        $variantInput.addClass("d-none");
      }
    }
  });

  // for 2nd step
  $(".modelSelect").on("change", function () {
    const $form = $(this).closest("form");
    $form.find(".varientContainer").removeClass("d-none");
  });

  $(".model").on("input", function () {
    const $form = $(this).closest("form");
    $form.find(".varientInput").closest(".form-floating").removeClass("d-none");
  });
});